import { useCallback } from 'react';
import { useAnalyticsEvents, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useTriggerIssueCreateModal } from '@atlassian/jira-packages-controllers-use-trigger-issue-create-modal/src/main.tsx';
import { useInProgressIssueActions } from '@atlassian/jira-issue-create-restore/src/controllers/in-progress-issue/index.tsx';
import type { ManageFieldActionSubjectId } from '../../common/constants/analytics.tsx';

export type UseOpenManageFieldTabProps = {
	source: ManageFieldActionSubjectId;
	url: string;
};
export const useOpenManageFieldTab = ({ source, url }: UseOpenManageFieldTabProps) => {
	const [{ inProgressIssueID }] = useTriggerIssueCreateModal();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { onModalClosed } = useInProgressIssueActions();

	const openManageWorkTypesTab = useCallback(() => {
		if (inProgressIssueID) {
			// This will help prevent GIC modal from triggering in new tab
			onModalClosed({ inProgressIssueID });
			fireUIAnalytics(
				createAnalyticsEvent({
					action: 'clicked',
					actionSubject: 'button',
				}),
				source,
			);

			globalThis.window?.open(url, '_blank');
		}
	}, [createAnalyticsEvent, inProgressIssueID, onModalClosed, source, url]);

	return openManageWorkTypesTab;
};
